// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_8xT","cls2":"Comments-cls2_2Oc Comments-cls1_8xT"};